import { render, staticRenderFns } from "./GoodsScan.vue?vue&type=template&id=53cd9acb&"
import script from "./GoodsScan.vue?vue&type=script&lang=js&"
export * from "./GoodsScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports